import * as constants from './constants';
import { guardNullOrUndefined } from '../utils/guards';

export const initializeTrovit = data => {
  guardNullOrUndefined(data);
  return { type: constants.INITIALIZE_TROVIT, data };
};

export const updateTrovit = data => {
  guardNullOrUndefined(data);
  return { type: constants.UPDATE_TROVIT, data };
};

export const setQueryTrovit = data => {
  guardNullOrUndefined(data);
  return { type: constants.SET_QUERY_TROVIT, data };
};

export const initializeConfig = config => {
  guardNullOrUndefined(config);
  return { type: constants.INITIALIZE_CONFIG, data: config };
};

export const fetchIndexSeoStart = () => ({ type: constants.FETCH_INDEX_SEO_START });

export const fetchIndexSeoRequest = data => {
  guardNullOrUndefined(data);
  return { type: constants.FETCH_INDEX_SEO_REQUEST, data };
};

export const fetchIndexSeoSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.FETCH_INDEX_SEO_SUCCESS, data };
};

export const fetchIndexSeoFailed = error => {
  guardNullOrUndefined(error);
  return { type: constants.FETCH_INDEX_SEO_FAILED, error };
};

export const hideDownloadAppBanner = () => ({ type: constants.HIDE_DOWNLOAD_APP_BANNER });

export const hidePermissionsBanner = isBlocked => {
  guardNullOrUndefined(isBlocked);
  return { type: constants.HIDE_PERMISSIONS_BANNER, isBlocked };
};

export const resetPermissionsBanner = () => ({ type: constants.RESET_PERMISSIONS_BANNER });

export const saveLastSearch = url => ({
  type: constants.SAVE_LAST_SEARCH,
  payload: url,
});

export const showPermissionsEmailBanner = () => ({ type: constants.SHOW_PERMISSIONS_EMAIL_BANNER });

export const hidePermissionsEmailBanner = () => ({ type: constants.HIDE_PERMISSIONS_EMAIL_BANNER });



// WEBPACK FOOTER //
// ./app/Index/actions.js